<template>
    <div>
        <Card>
            <template #title>
                Pendências
            </template>
            <template #content>
                <Toolbar class="mb-2 bg-gray-100">
                    <template #start>
                        <div class="flex items-center gap-1">
                            <Button icon="pi pi-file-excel" label="Download" severity="success" size="small"
                                    @click="downloadData" />
                        </div>
                    </template>
                    <template #end>
                        <div class="flex items-center gap-1">
                            <Button icon="pi pi-search" label="Buscar" severity="sucess" size="small"
                                @click="toggleBusca" />
                            <Button icon="pi pi-refresh" label="Atualizar" severity="warn" size="small"
                                @click="loadData" />
                        </div>
                    </template>
                </Toolbar>

                <DataTable :value="lista" :loading="isLoading" size="small" stripedRows showGridlines scrollable
                    scrollHeight="calc(100vh - 300px)" :sortField="params.sort.field" :sortOrder="params.sort.order"
                    @sort="onTableSort">

                    <Column style="width: 100px" field="id" header="#" sortable></Column>
                    <Column field="descricao" header="Descrição" sortable></Column>
                    <Column field="id_primario" header="ID Primário" sortable></Column>
                    <Column field="id_secundario" header="ID Secundário" sortable></Column>
                    <Column field="categoria" header="Categoria" sortable></Column>
                    <Column field="etapa" header="Etapa" sortable></Column>
                    <Column field="created_at" header="Data/Hora" sortable>
                        <template #body="{ data }">
                            {{ dateFormat(data.created_at) }}
                            <span v-if="!data.resolvido" class="font-italic">
                                ({{ data.dias }} dias)
                            </span>
                        </template>
                    </Column>
                    <Column style="width: 150px" bodyClass="flex justify-content-end gap-1">
                        <template #body="{ data }">
                            <i v-if="data.resolvido" class="pi pi-check-square text-green-400 flex align-items-center" v-tooltip.top="'Resolvido'"></i>
                            <i v-else class="pi pi-check-square text-red-400 flex align-items-center" v-tooltip.top="'Pendente'"></i>

                            <Button icon="pi pi-file-check" title="Contrato" severity="help" size="small"
                                @click="openFormContrato(data)" />
                            <Button icon="pi pi-pen-to-square" title="Atualizar" severity="info" size="small"
                                @click="openForm(data)" />
                            <Button icon="pi pi-trash" title="Remover" severity="danger" size="small"
                                @click="remove(data)" />
                        </template>
                    </Column>

                    <template #empty>
                        <div class="text-center text-gray-600">
                            Nenhum registro encontrado
                        </div>
                    </template>
                </DataTable>

                <div class="flex justify-content-between flex-wrap">
                    <div class="flex align-items-center justify-content-center">
                        <div class="flex justify-end mt-2 text-sm text-gray-600">
                            <span>{{ pagination.total }} registros</span>
                        </div>

                    </div>
                    <div class="flex align-items-center justify-content-center">
                        <Paginator :first="pagination.first" :rows="pagination.perPage" :totalRecords="pagination.total"
                            @page="onPage">
                        </Paginator>
                    </div>
                    <div class="flex align-items-center justify-content-center">
                    </div>
                </div>

            </template>
        </Card>
        <PendenciaForm :visible="visibleForm" :data="item" @close="closeForm" @save="loadData" />
        <ContratoForm :visible="visibleFormContrato" :id="item.contrato_id" :permissoes="permissoes" @close="closeForm" @save="loadData" :etapa="'pendencias'" />

        <Popover ref="busca" :closeOnEscape="false" :dismissable="false" class="w-3">
            <div class="w-full">
                <form @submit.prevent="onSubmitBusca">
                    <div class="w-full">
                        <div class="field mt-4">
                            <FloatLabel>
                                <InputText id="descricao" v-model="params.filter.descricao" class="w-full" />
                                <label for="descricao">Pendência</label>
                            </FloatLabel>
                        </div>
                        <div class="field mt-4">
                            <FloatLabel>
                                <InputText id="contrato" v-model="params.filter.contrato" class="w-full" />
                                <label for="contrato">ID Primario e ID Secundario</label>
                            </FloatLabel>
                        </div>
                        <div class="field mt-4">
                            <FloatLabel>
                                <InputText v-model="params.filter['site']" class="w-full" />
                                <label>Site/Localidade</label>
                            </FloatLabel>
                        </div>

                        <div class="field mt-4">
                            <FloatLabel>
                                <MultiSelect v-model="params.filter['pen.etapa']" display="chip" :maxSelectedLabels="6"
                                    :options="etapaOpt" optionLabel="descricao" filter
                                    class="w-full" optionValue="id" />
                                <label>Etapa</label>
                            </FloatLabel>
                        </div>

                        <div class="field mt-4">
                            <FloatLabel>
                                <MultiSelect v-model="params.filter['pen.categoria_id']" display="chip" :maxSelectedLabels="6"
                                    :options="categoriaOpt" optionLabel="descricao" filter
                                    class="w-full" optionValue="id" />
                                <label>Categoria</label>
                            </FloatLabel>
                        </div>

                        <div class="field mt-4">
                            <FloatLabel>
                                <Select id="resolvido" v-model="params.filter.resolvido" :options="statusOptions"
                                    optionLabel="label" optionValue="value" :showClear="true" class="w-full" />
                                <label for="ativo">Status</label>
                            </FloatLabel>
                        </div>
                        <div class="flex gap-1">
                            <div class="field mt-1">
                                <FloatLabel>
                                    <DatePicker id="created_at_inicio" v-model="params.filter.created_at_inicio" showIcon
                                        class="w-full" dateFormat="dd/mm/yy" />
                                    <label for="created_at_inicio">Criação Inicio</label>
                                </FloatLabel>
                            </div>
                            <div class="field mt-1">
                                <FloatLabel>
                                    <DatePicker id="created_at_fim" v-model="params.filter.created_at_fim" showIcon
                                        class="w-full" dateFormat="dd/mm/yy" />
                                    <label for="created_at_fim">Criação Fim</label>
                                </FloatLabel>
                            </div>
                        </div>
                    </div>

                    <div class="flex justify-content-end gap-1">
                        <Button type="submit" label="Buscar" severity="success" icon="pi pi-search"
                            class="flex align-items-center justify-content-center" />
                        <Button icon="pi pi-eraser" label="Limpar" severity="warn" size="small"
                            class="flex align-items-center justify-content-center" @click="onClearBusca" />
                        <Button icon="pi pi-times" label="Fechar" severity="danger" size="small"
                            class="flex align-items-center justify-content-center" @click="toggleBusca" />
                    </div>
                </form>
            </div>

        </Popover>
    </div>
</template>
<script>
import Card from 'primevue/card';

/* Table */
import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Paginator from 'primevue/paginator';
import Column from 'primevue/column';
import Popover from 'primevue/popover';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import MultiSelect from 'primevue/multiselect';
import DatePicker from 'primevue/datepicker';

import PendenciaForm from '@/page/pendencia/Form.vue';
import ContratoForm from '@/page/contrato/Form.vue';

import Pendencia from '@/service/pendencia.js';
import PendenciaCategoria from '@/service/pendenciaCategoria.js';
import Etapa from '@/service/etapa.js';

import Filter from '@/utils/Filter.js';
import File from '@/utils/File.js';

import Moment from 'moment';

export default {
    components: {
        Card,
        Toolbar,
        Button,
        DataTable,
        Paginator,
        Column,
        DatePicker,
        MultiSelect,

        /* Busca */
        Popover,
        FloatLabel,
        InputText,
        Select,

        /* Form */
        PendenciaForm,
        ContratoForm,
    },
    data() {
        return {
            lista: [],
            isLoading: false,
            item: {},
            visibleForm: false,
            visibleFormContrato: false,

            params: {
                filter: {},
                sort: {
                    field: 'id',
                    order: 1
                }
            },
            pagination: {
                page: 0,
                perPage: 0,
                total: 0,
            },
            permissoes: permissoes,

            statusOptions: [
                { label: 'Resolvido', value: 1 },
                { label: 'Pendente', value: 0 }
            ],

            etapaOpt: [],
            isLoadingEtapaOpt: false,

            categoriaOpt: [],
            isLoadingCategoriaOpt: false,
        }
    },
    beforeMount() {
        this.params.page = parseInt(this.$route.query.page || 0);
        document.addEventListener("onPermissios", event => this.permissoes = event.permissoes);
    },
    mounted() {
        this.loadData();
        this.loadEtapaOpt();
        this.loadCategoriaOpt();
    },
    methods: {

        dateFormat(value) {
            if (!value) return;
            return Moment(value).format("DD/MM/YYYY HH:mm");
        },

        openForm(item) {
            this.item = { ...item };
            this.visibleForm = true;
        },
        openFormContrato(item) {
            this.item = { ...item };
            this.visibleFormContrato = true;
        },
        closeForm(event) {
            this.item = {};
            this.visibleForm = false;
            this.visibleFormContrato = false;
        },
        remove(data) {
            this.$confirm.require({
                message: 'Deseja realmente remover o item?',
                header: 'Remover',
                acceptLabel: 'Remover',
                icon: 'pi pi-trash',
                acceptClass: 'bg-red-500 text-white border-red-500',
                rejectLabel: 'Cancelar',
                rejectClass: 'bg-red-400 text-white',
                accept: () => {
                    this.isLoading = true;
                    Pendencia.delete(data.id)
                        .then(response => {
                            this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'O item foi removido com sucesso.', life: 3000 });
                            this.loadData();
                        })
                        .catch(error => {
                            if (error.response) {
                                let err = error.response.data;
                                if (err.erros) {
                                    for (let i in err.erros) {
                                        this.errors[i] = err.erros[i][0];
                                    }
                                    return;
                                }
                                if (error.response.data.msg) {
                                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                                    return;
                                }
                            }
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                },
            });
        },
        loadEtapaOpt() {
            this.isLoadingEtapaOpt = true;
            Etapa.option(['order[descricao]=asc'].join("&"))
                .then(response => {
                    this.etapaOpt = response.data;
                })
                .finally(() => {
                    this.isLoadingEtapaOpt = false;
                });
        },
        loadCategoriaOpt() {
            this.isLoadingCategoriaOpt = true;
            PendenciaCategoria.option(['order[descricao]=asc'].join("&"))
                .then(response => {
                    this.categoriaOpt = response.data;
                })
                .finally(() => {
                    this.isLoadingCategoriaOpt = false;
                });
        },
        loadDataParams() {
            let params = [];

            // Pagination
            params.push(`page=${1 + this.params.page}`);

            // Filter
            params = Filter.formToQuery(this.params.filter, params);

            // Order
            params.push(`order[${this.params.sort.field}]=` + (this.params.sort.order > 0 ? 'asc' : 'desc'));
            return params;
        },
        downloadData() {
            let params = this.loadDataParams();

            this.isLoading = true;
            Pendencia.download(params.join("&"))
                .then(response => {
                    File.downloadBlob(response);
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        loadData() {
            let params      = this.loadDataParams();

            this.isLoading  = true;
            Pendencia.list(params.join("&"))
                .then(response => {
                    this.lista = response.data.data;

                    this.pagination.perPage = response.data.per_page;
                    this.pagination.total = response.data.total;
                    this.pagination.first = response.data.per_page * this.params.page;
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        // Filter
        toggleBusca(event) {
            this.$refs.busca.toggle(event);
        },
        onClearBusca(event) {
            this.toggleBusca(event);
            this.params.filter = {};
            this.onPage();
        },
        onSubmitBusca(event) {
            this.toggleBusca(event);
            this.onPage();
        },

        // Paginate
        onPage(event) {
            const page = event ? event.page : 0;
            this.params.page = page;
            this.$router.replace({ name: this.$route.name, query: { page: page } });
            this.loadData();
        },

        // Sort
        onTableSort(event) {
            this.params.sort = {
                field: event.sortField,
                order: event.sortOrder,
            };
            this.loadData();
        }
    }
}
</script>
